<template>
  <div class="teachers-info-disclosure">
    <div class="title-wrap">
      <p class="title">教师信息公示</p>
      <p class="translate">Teacher Information Disclosure</p>
    </div>
    <div class="tabs-wrap">
      <div :class="['tabs-item', item.key === curTab ? 'active' : '']" v-for="item in tabsList" :key="item.key" @click="swicthTabs(item)">{{ item.value }}</div>
    </div>
    <div class="teachers-list-wrap">
      <div class="teachers-list">
        <div class="item" v-for="item in teacherList" :key="item.number">
          <div :style="`background:url(${item.avatar}) center/cover no-repeat`"></div>
          <p>{{ item.name }}</p>
          <p>教师资格证编号</p>
          <p>{{ item.number }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { getTeacherList } from '@/api/teacher.js';

@Component({
  components: {}
})
export default class TeachersInfo extends Vue {
  curTab = 1;
  tabsList = [
    {
      key: 1,
      value: "语文"
    },
    {
      key: 2,
      value: "数学"
    },
    {
      key: 3,
      value: "英语"
    }
  ];

  // 语文老师列表
  chineseTeacherList = [];
  
  // 数学老师列表
  mathTeacherList = [];

  // 英语老师列表
  englishTeacherList = [];

  teacherList = [];

  async mounted() {
    const { code, data, message } = await getTeacherList();

    if (code === 0) {
      data.forEach(cur => {
        const {
          subject,
          pic,
          name,
          certNum
        } = cur;

        const teacher = {
          name,
          number: certNum,
          avatar: pic
        };

        switch (subject) {
          case '语文':
            this.chineseTeacherList.push(teacher);
            break;
          case '数学':
            this.mathTeacherList.push(teacher);
            break;
          case '英语':
            this.englishTeacherList.push(teacher);
            break;
        }
      });
    } else {
      console.log(message);
    }

    // 教师列表
    this.teacherList = this.chineseTeacherList;
  }

  swicthTabs(item) {
    this.curTab = item.key;
    switch (item.key) {
      case 1:
        this.teacherList = this.chineseTeacherList;
        break;
      case 2:
        this.teacherList = this.mathTeacherList;
        break;
      case 3:
        this.teacherList = this.englishTeacherList;
        break;
    }
  }
}
</script>
<style lang="scss">
.teachers-info-disclosure {
  padding-top: 100px;
  .title-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 300px;
    background: url(data:image/png;base64,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)
      no-repeat;
    .title {
      color: #ffffff;
      font-size: 64px;
      margin-bottom: 20px;
    }
    .translate {
      color: #ffddc6;
      font-size: 22px;
    }
  }
  .tabs-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-bottom: 2px solid #b8c0c8;
    .tabs-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 88px;
      margin: 0 79px;
      padding: 0;
      min-width: 0;
      color: #808080;
      opacity: 0.7;
      font-size: 36px;
      cursor: pointer;
      &.active {
        color: #ff6900 !important;
        opacity: 1 !important;
        border-bottom: 5px solid #ff6900 !important;
      }
    }
  }
  .teachers-list-wrap {
    background: url("https://ketang.knowbox.cn/static/media/bg.b0fc2b74.png") no-repeat;
    background-size: cover;
    background-position-y: -500px;
    .teachers-list {
      max-width: 1200px;
      margin: auto;
      padding: 87px 0;
      display: flex;
      flex-flow: row wrap;
      // justify-content: space-between;
      .item {
        display: flex;
        justify-content: center;
        width: 25%;
        flex-direction: column;
        align-items: center;
        // margin-right: 60px;
        margin-bottom: 95px;
        img {
          border-radius: 150px;
          box-shadow: 0 16px 21px 0 #c0cbe4bf;
          margin-bottom: 33px;
        }
        div:first-child {
          width: 237px;
          height: 237px;
          border-radius: 150px;
          box-shadow: 0 16px 21px 0 #c0cbe4bf;
          margin-bottom: 33px;
        }
        p:nth-child(2) {
          font-size: 28px;
          line-height: 1;
          color: #405b86;
          margin-bottom: 15px;
        }
        p:nth-child(3) {
          font-size: 22px;
          line-height: 1;
          color: #b8c0c8;
          margin-bottom: 9px;
        }
        p:last-child {
          font-size: 20px;
          line-height: 1;
          color: #b8c0c8;
        }
      }
    }
  }
}
</style>
